import {
  createSlice,
  PayloadAction,

} from "@reduxjs/toolkit";

import { ProjectDetails } from "types";
import { StatusState } from "store/types";
import { fetchProjectById } from "./projectDetails.actions";
import { ProjectDetailsProcessedData, ProjectDetailsState } from "./ptrojectDetails.types";



const initialState: ProjectDetailsState = {
  data: null,
  statusState:StatusState.IDLE,
  error: null,
  processedData: null,
};

export const projectDetailsSlice = createSlice({
  name: "projectDetails",
  initialState,
  reducers: {
    setProjectDetails:(state,action:PayloadAction<ProjectDetails>)=>{
      state.data = action.payload;
    },
    setProcessedData:(state,action:PayloadAction<ProjectDetailsProcessedData>)=>{
      state.processedData = action.payload;
    },
    resetProjectDetailsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectById.pending, (state) => {
        state.statusState = StatusState.LOADING;
        state.error = null;
      })
      .addCase(fetchProjectById.fulfilled, (state) => {
        state.statusState = StatusState.SUCCEEDED;
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.statusState = StatusState.FAILED;
        state.error = action.payload as string;
      });
  },
});

export const { resetProjectDetailsState, setProjectDetails, setProcessedData } = projectDetailsSlice.actions;

const projectDetailsReducer = projectDetailsSlice.reducer
export default projectDetailsReducer;
